/* eslint-disable eslint-comments/disable-enable-pair, react/jsx-max-depth */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import { collectEmployerClick } from 'src/utils/analytics/applyTo';
import PictureSource from 'src/components/ApplyTo/PictureSource';
import styles from 'src/components/ApplyTo/Company.scss';


// eslint-disable-next-line max-lines-per-function
const Company = ({
  name, employerId, index, logos: { mobile, desktop, defaultImage }, profileUrl, isSingle
}) => {
  const linkStyles = classNames({
    [styles.company]: true,
    [styles['company--single']]: isSingle
  });

  const logoStyle = classNames({
    [styles['company-logo']]: true,
    [styles['company-logo--single']]: isSingle
  });

  const desktopLogoStyles = classNames({
    [styles['company-logo__desktop']]: true,
    [styles['company-logo__desktop--single']]: isSingle
  });

  const nameStyles = classNames({
    [styles.company__name]: true,
    [styles['company__name--single']]: isSingle
  });

  return (
    <a
      className={ linkStyles }
      data-test="anchor-applyToCompanyTile"
      href={ profileUrl }
      onClick={
         event => collectEmployerClick(event, {
           employerId,
           employerName: name,
           index
         }, profileUrl)
       }
    >
      <div
        className={ logoStyle }
        data-test="company-logo"
      >
        <picture data-test="company-logo-image-mobile" styleName="company-logo__mobile">
          <PictureSource
            defaultImage={ defaultImage }
            device={ mobile }
            isSingle={ isSingle }
            name={ name }
          />
        </picture>
        <picture className={ desktopLogoStyles } data-test="company-logo-image-desktop">
          <PictureSource
            defaultImage={ defaultImage }
            device={ desktop }
            isSingle={ isSingle }
            name={ name }
          />
        </picture>
      </div>

      <span className={ nameStyles }>
        {name}
      </span>
    </a>
  );
};

Company.propTypes = {
  employerId: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isSingle: PropTypes.bool.isRequired,
  logos: PropTypes.shape({
    defaultImage: PropTypes.object,
    desktop: PropTypes.shape({
      deviceWidth: PropTypes.string,
      images: PropTypes.array
    }),
    mobile: PropTypes.shape({
      deviceWidth: PropTypes.string,
      images: PropTypes.array
    })
  }).isRequired,
  name: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired
};

export default Company;
